module.exports = __webpack_public_path__ + "img/forgetpassword.f16bfaca.svg";